import React, { useState } from "react";
import DrawerFilter from "../../../components/listing/DrawerFilter";

export default function FiltroZona({ initialFilters = {}, onSubmit = () => {}, onClose = () => {} }) {
  const [nombre, setNombre] = useState(initialFilters.nombre || "");

  const handleApply = () => {
    onSubmit({ nombre: nombre.trim() });
    onClose();
  };

  return (
    <DrawerFilter title="Filtros de Zonas" onClose={onClose} onApply={handleApply}>
      <div>
        <label className="form-label-fil">Nombre:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          placeholder="Buscar por nombre..."
        />
      </div>
    </DrawerFilter>
  );
}